<template>
  <div class="jp-common-layout page">
    <div class="jp-common-layout-left">
      <div class="jp-common-title"> 
        <el-input
          placeholder="组织机构:请输入关键字过滤"
          size="small"
          clearable
          v-model="filterText">
        </el-input>
      </div>
      <div class="jp-common-el-tree-scrollbar el-scrollbar">
        <div class="el-scrollbar__wrap">
          <div class="el-scrollbar__view">
              <el-tree
                class="filter-tree jp-common-el-tree"
                :render-content="renderContent"
                :data="officeTreeData"
                :props="{
                      value: 'id',             // ID字段名
                      label: 'name',         // 显示名称
                      children: 'children'    // 子级字段名
                    }"
                node-key="id"
                default-expand-all
                :filter-node-method="filterNode"
                :expand-on-click-node="false"
                highlight-current
                @node-click="handleNodeClick"
                ref="officeTree">
              </el-tree>
          </div>
        </div>
      </div>
    </div>
    <div class="jp-common-layout-center jp-flex-main">
      <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
        <!-- 搜索框-->
        <el-form-item prop="nameEn">
          <el-input size="small" v-model="searchForm.nameEn" placeholder="英文名称" clearable></el-input>
        </el-form-item>
        <el-form-item prop="nameCn">
          <el-input size="small" v-model="searchForm.nameCn" placeholder="中文名称" clearable></el-input>
        </el-form-item>
        <el-form-item prop="spaceIdsStr">
          <GridSelect
            title="选择功能空间"
            placeholder="请选择功能空间"
            labelName = 'nameEn'
            labelValue = 'id'
            :value = "searchForm.spaceIdsStr"
            :limit="10"
            size="small"
            @getValue='(value) => {searchForm.spaceIdsStr=value}'
            :columns="[
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            :searchs="[
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            dataListUrl="/unmspace/cecUnmFunctionalSpace/list"
            queryEntityUrl="/unmspace/cecUnmFunctionalSpace/queryById">
          </GridSelect>
        </el-form-item>
        <el-form-item prop="projectIdsStr">
          <GridSelect
            title="选择项目"
            placeholder="请选择项目"
            labelName = 'nameCn'
            labelValue = 'id'
            :value = "searchForm.projectIdsStr"
            :limit="10"
            size="small"
            @getValue='(value) => {searchForm.projectIdsStr=value}'
            :columns="[
              {
                prop: 'code',
                label: '编码'
              },
              {
                prop: 'nameCn',
                label: '中文名称'
              },
              {
                prop: 'nameEn',
                label: '英文名称'
              }
            ]"
            :searchs="[
              {
              prop: 'code',
              label: '编码'
              },
              {
                prop: 'nameCn',
                label: '中文名称'
              },
              {
                prop: 'nameEn',
                label: '英文名称'
              }
            ]"
            dataListUrl="/unmspace/cecUnmProject/list"
            queryEntityUrl="/unmspace/cecUnmProject/queryById">
          </GridSelect>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
          <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="bg-white top">
        <vxe-toolbar :refresh="{query: refreshList}" import export print custom>
          <template #buttons>
            <el-button v-if="hasPermission('unmspace:cecUnmSpace:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button>
            <!-- <el-button v-if="hasPermission('unmspace:cecUnmSpace:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecUnmSpaceTable && $refs.cecUnmSpaceTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
            <el-button v-if="hasPermission('unmspace:cecUnmSpace:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecUnmSpaceTable && $refs.cecUnmSpaceTable.getCheckboxRecords().length === 0" plain>删除</el-button>
          </template>
          <template #tools>
            <vxe-button
              type="default"
              title="下载导入模板"
              v-if="hasPermission('unmspace:cecUnmSpace:import')"
              class="el-icon-document m-r-12"
              @click="downloadTpl()"
              circle>
            </vxe-button>
          </template>
        </vxe-toolbar>
        <div style="height: calc(100% - 80px);">
          <vxe-table
            border="full"
            auto-resize
            resizable
            height="auto"
            :loading="loading"
            size="small"
            ref="cecUnmSpaceTable"
            show-header-overflow
            show-overflow
            highlight-hover-row
            :menu-config="{}"
            :print-config="{}"
            :import-config="{
            importMethod: importMethod,
                types: ['csv', 'xls', 'xlsx'],
                remote: true,
            }"
            :export-config="{
                remote: true,
                filename: `空间表数据${moment(new Date()).format(
            		'YYYY-MM-DD'
                )}`,
                sheetName: '空间表数据',
                exportMethod: exportMethod,
                types: ['xlsx'],
                modes: ['current', 'selected', 'all'],
            }"
            @sort-change="sortChangeHandle"
            :sort-config="{remote:true}"
            :data="dataList"
            :checkbox-config="{}">
          <!-- <vxe-column type="seq" width="40"></vxe-column> -->
          <vxe-column type="checkbox"  width="40px"></vxe-column>
          <vxe-column
            field="sort"
            align="center"
            width="50"
            title="排序">
          </vxe-column>
          <vxe-column
            field="nameCn"
            align="center"
            title="中文名称">
                <template slot-scope="scope">
                  <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmspace:cecUnmSpace:edit')" @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
                  <el-link  type="primary" :underline="false" v-if="hasPermission('unmspace:cecUnmSpace:view')"  @click="view(scope.row.id)">{{scope.row.nameCn}}</el-link>
                  <span v-else>{{scope.row.nameCn}}</span>
                </template>
          </vxe-column>
          <vxe-column
            field="nameEn"
            align="center"
            title="英文名称">
          </vxe-column>
          <vxe-column
            field="functionalSpaceIds.nameEn"
            align="center"
            title="功能空间">
              <template slot-scope="scope">
                  <!-- {{scope.row.functionalSpaceIds && scope.row.functionalSpaceIds.nameEn}} -->
                  <div v-if="!scope.row.functionalSpaceIds">
                    -
                  </div>
                  <PopoverTip
                    v-else
                    labelValue = 'id'
                    :value = "scope.row.functionalSpaceIds.id"
                    :columns="[
                      {
                        prop: 'sort',
                        label: '序号'
                      },
                      {
                        prop: 'nameCn',
                        label: '中文名称'
                      },
                      {
                        prop: 'nameEn',
                        label: '英文名称'
                      },
                      {
                        prop: 'defaultValue.nameEn',
                        label: '默认值'
                      },
                      {
                        prop: 'address',
                        label: '备注'
                      }
                    ]"
                    dataListUrl="/unmspace/cecUnmFunctionalSpace/list"
                    queryEntityUrl="/unmspace/cecUnmFunctionalSpace/queryById"
                  ></PopoverTip>
              </template>
          </vxe-column>
          <vxe-column
            field="projectIds.nameCn"
            align="center"
            title="关联项目">
            <template slot-scope="scope">
              <div v-if="!scope.row.projectIds">
                -
              </div>
              <PopoverTipList
                v-else
                labelValue = 'id'
                :value = "scope.row.projectIds.id"
                :sortDisabled="true"
                :columns="[
                  {
                    prop: 'code',
                    label: '编号'
                  },
                  {
                    prop: 'nameCn',
                    label: '中文名称'
                  },
                  {
                    prop: 'nameEn',
                    label: '英文名称'
                  },
                  {
                    prop: 'pic',
                    label: '图片'
                  }
                ]"
                :selectArray="scope.row.projectLis"
                dataListUrl="/unmspace/cecUnmProject/list"
                queryEntityUrl="/unmspace/cecUnmProject/queryById"
              ></PopoverTipList>
            </template>
          </vxe-column>
          <!-- <vxe-column
            fixed="right"
            align="center"
            width="200"
            title="操作">
            <template  slot-scope="scope">
              <el-button v-if="hasPermission('unmspace:cecUnmSpace:view')" type="text" icon="el-icon-view" size="small" @click="view(scope.row.id)">查看</el-button>
              <el-button v-if="hasPermission('unmspace:cecUnmSpace:edit')" type="text" icon="el-icon-edit" size="small" @click="edit(scope.row.id)">修改</el-button>
              <el-button v-if="hasPermission('unmspace:cecUnmSpace:del')" type="text"  icon="el-icon-delete" size="small" @click="del(scope.row.id)">删除</el-button>
            </template>
          </vxe-column> -->
        </vxe-table>
        <vxe-pager
          background
          size="small"
          :current-page="tablePage.currentPage"
          :page-size="tablePage.pageSize"
          :total="tablePage.total"
          :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
          @page-change="currentChangeHandle">
        </vxe-pager>
      </div>
      </div>
        <!-- 弹窗, 新增 / 修改 -->
      <CecUnmSpaceForm  ref="cecUnmSpaceForm" @refreshDataList="refreshList"></CecUnmSpaceForm>
    </div>
  </div>
</template>

<script>
  import CecUnmSpaceForm from './CecUnmSpaceForm'
  import cecUnmSpaceService from '@/api/unmspace/cecUnmSpaceService'
  import GridSelect from '@/components/gridSelect/setIndex.vue'
  import PopoverTip from '@/components/popoverTip'
  import PopoverTipList from '@/components/popoverTip/indexList.vue'
  export default {
    data () {
      return {
        searchForm: {
          nameEn: '',
          nameCn: '',
          projectIdsStr: '',
          spaceIdsStr: '',
          type: ''
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'a.create_date', asc: true }]
        },
        loading: false,
        filterText: '',
        officeTreeData: []
      }
    },
    components: {
      GridSelect,
      CecUnmSpaceForm,
      PopoverTip,
      PopoverTipList
    },
    activated () {
      this.refreshList()
      this.getDictTypeList()
    },
    watch: {
      filterText (val) {
        this.$refs.officeTree.filter(val)
      }
    },
    methods: {
      filterNode (value, data) {
        if (!value) return true
        return data.name.indexOf(value) !== -1
      },
      renderContent (h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
            <span class="text">{node.label}</span>
          </span>
        )
      },
      handleNodeClick (data) {
        if (data.id === '') {
          this.searchForm.type = ''
        } else {
          this.searchForm.type = data.id
        }
        this.refreshList()
      },
      // 获取类型
      getDictTypeList () {
        let treeData = [
          {
            id: '',
            name: '平屋',
            children: this.$dictUtils.getDictList('cec_room').map(item => {
              let m = {
                id: item.id,
                name: item.label,
                children: []
              }
              return m
            })
          }
        ]
        this.officeTreeData = treeData
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        cecUnmSpaceService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'a.create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecUnmSpaceForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecUnmSpaceTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecUnmSpaceForm.init('edit', id)
      },
      // 查看
      view (id) {
        this.$refs.cecUnmSpaceForm.init('view', id)
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecUnmSpaceTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmSpaceService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        cecUnmSpaceService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        cecUnmSpaceService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return cecUnmSpaceService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.refreshList()
      }
    }
  }
</script>

